import React from "react";

const Loading = ({ width }) => {
  return (
    <div className="flex justify-center items-center w-full h-screen">
      <img src="/loading.gif" className={`self-center ${width}`} />
    </div>
  );
};

export default Loading;
